<template>
  <div class="factory" :class="{lift:!hidePlant}">
    <b-loading class="loading" :is-full-page="false" :active.sync="isLoading"></b-loading>

    <div class="columns is-mobile">
      <div class="column is-6">TreasureMine id: {{factory.id}}</div>
      <div class="column is-6">Time: {{factory.timeToGrown}} min</div>
    </div>
    <div class="formula columns is-multiline is-mobile">
      <div class="column is-8-desktop is-12-mobile">
        <div class="in-els columns is-variable is-1 is-multiline is-mobile">
          <div class="column is-12 label">In elements</div>

          <div class="in-el column is-2" v-for="i in factory.inElements" :key="'in'+i.id">
            <ElementSmall :element="elements[i.id]" :ratio="i.sampleValue" />
          </div>
        </div>
      </div>
      <div class="column is-4-desktop is-12-mobile">
        <div class="out-els columns is-variable is-1 is-multiline is-mobile">
          <div class="column is-12 label">Out elements</div>
          <div
            class="out-el column is-4-desktop is-2-mobile"
            v-for="i in factory.outElements"
            :key="'out'+i.id"
          >
            <ElementSmall :element="elements[i.id]" :ratio="i.sampleValue" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hidePlant" class="columns is-mobile is-centered">
      <div class="column is-half">
        <div class="plant-input columns is-multiline is-centered">
          <b-numberinput
            class="column"
            controls-position="compact"
            min="1"
            size="is-small"
            v-model="mulSeed"
          ></b-numberinput>
          <div class="column text-center">
            <div class="button is-primary is-small" @click="plant(mulSeed)">Begin mining!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ElementSmall from "@/components/ElementSmall";
import contract from "./../Utils/Contract.js";

export default {
  components: { ElementSmall },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    factory: Object,
    mulSeed: {
      type: Number,
      default: 1
    },
    hidePlant: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    elements: function() {
      return contract.elements;
    }
  },
  watch: {
    mulSeed: function(val) {
      this.updateSampleData(val);
    }
  },
  created() {
    this.updateSampleData(this.mulSeed);
  },
  methods: {
    updateSampleData: function(val) {
      this.factory.inElements.forEach((element, index, elements) => {
        elements[index].sampleValue = elements[index].ratio * val;
      });
      this.factory.outElements.forEach((element, index, elements) => {
        elements[index].sampleValue = elements[index].ratio * val;
      });
    },
    plant: async function(mulSeed) {
      try {
        this.isLoading = true;
        await contract.plant(this.factory.id, mulSeed);
        this.isLoading = false;
        this.$toast.open({
          message: "Treasure mining initiation is a success!",
          type: "is-success"
        });
      } catch (e) {
        this.isLoading = false;
        this.$toast.open({
          message: e.toString(),
          type: "is-danger"
        });
      }
    }
  }
};
</script>

<style>
.loading {
  z-index: 999;
}
.text-center {
  text-align: center;
}
.lift:hover {
  transform: scale(1.05);
  box-shadow: rgba(31, 42, 75, 0.3) 0px 20px 40px;
}
.lift {
  box-shadow: rgba(31, 42, 75, 0.2) 0px 20px 40px;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1) 0s;
}
.factory {
  font-size: small;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px;
  cursor: pointer;

  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
.factory .out-els,
.in-els {
  border: 0.5px dashed #b8b8b8; /* content: "hihih"; */
  border-radius: 10px;
  /* box-shadow: inset 0px 0px 4px 1px; */
  /* padding: 0px 5px 0px 5px; */
  margin: 0px;
}
.in-els .label,
.out-els .label {
  padding: 0px;
  margin: 0;
  font-weight: bold;
  text-align: center;
  font-size: small;
  color: rgb(0, 69, 71);
}
</style>
